import { createFileRoute } from '@tanstack/react-router';

import { OrgJobsPage } from '@/features/talent/jobs-pages';

export const Route = createFileRoute('/_app/org/$orgId/jobs')({ component: OrgRoute });

function OrgRoute() {
  const { orgId } = Route.useParams();
  return <OrgJobsPage orgId={orgId} />;
}
